<div class="vertical-container-simple column-gap-0p25">
  <label *ngIf="title" class="input-title">
    {{ title }}<span *ngIf="props.required" class="red-10">*</span>
  </label>
  <div
    data-qa="selector-auto-complete"
    class="control cursor-pointer"
    (click)="showPopUpModal = props.openOnClick">
    <span class="control-text">
      {{ isSimpleArray ? selectedItem : selectedItem[field] }}
    </span>
    <div class="suffix">
      <img src="../../../../assets/svg/common/arrow-down.svg" alt="dropdown">
    </div>
  </div>

  <ng-container *ngIf="props.openOnClick; then openOnClickBlock; else openOnHoverBlock"></ng-container>
  <ng-template #openOnClickBlock>
    <app-popup-modal *ngIf="showPopUpModal" [innerModal]="isInsideModal" (closeModal)="showPopUpModal=false">
      <div class="picker centered-column-container full-opacity">
        <div class="picker-dropdown centered-column-container full-opacity width-unset"
             [ngClass]="outerClass === 'control-container-without-border' ? 'auto-width' : ''" #dropdown>
          <app-input class="flex width-100pcnt" (inputChange)="searchInputValue$.next($event)" [autofocus]="true">
          </app-input>
          <div class="centered-column-container picker-list">
            <div class="centered-column-container list-block">
              @for (item of filteredData | async; track item) {
                <div
                  class="w-full min-height-2 start-row-container"
                  [attr.data-qa]="'list-entry-selected-item'"
                  [class.no-propagation]="isDataReadyForPickerCssStructure && item.isHeader"
                  [class.bg-black-2]="selectedItem === item || (field && selectedItem[field] === item[field])"
                  (click)="setSelected(item)">
                  @if (isDataReadyForPickerCssStructure) {
                    @if (item.isHeader) {
                      <span
                        data-qa="selector-autocomplete-header"
                        class="list-subheader start-row-container">
                          {{ item.header }}
                        </span>
                    } @else {
                      <div class="flex flex-row justify-between w-full list-entry sub-list"
                           [ngClass]="selectedItem === item.id ? ['bg-black-2', 'bold500'] : []">
                        <span
                          data-qa="selector-autocomplete-subheader">
                          {{ item.subheader }}
                        </span>
                        @if (item.comment) {
                          <span class="font-normal black-7">{{ item.comment }}</span>
                        }
                      </div>
                    }
                  } @else {
                    <span
                      data-qa="selector-autocomplete-header"
                      class="padding-0-0p46875 list-entry">
                      {{ isSimpleArray ? item : item[field] | linkShort:props.maxListEntryLength }}
                    </span>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </app-popup-modal>
  </ng-template>

  <ng-template #openOnHoverBlock>
    <div class="picker centered-column-container">
      <div class="picker-dropdown centered-column-container"
           [ngClass]="outerClass === 'control-container-without-border' ? 'auto-width' : ''" #dropdown>
        <div class="centered-column-container picker-list">
          <div class="centered-column-container list-block">
            <span class="list-entry" *ngFor="let item of filteredData | async" (click)="setSelected(item)">
              {{ isSimpleArray ? item : item[field] | linkShort:props.maxListEntryLength }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</div>
